 import React from 'react';
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { FaEnvelope, FaPhone, FaMapMarkerAlt, FaClock, FaHandsHelping, FaLeaf, FaSeedling } from "react-icons/fa";
import { Link } from 'react-router-dom';
import './contactus.css'; 

const ngos = [
  { name: "WWF Pakistan", problems: "Deforestation, Wildlife, Climate Change" },
  { name: "Pakistan Fisherfolk Forum", problems: "Water Pollution, Marine Life" },
  { name: "Urban Forest Pakistan", problems: "Tree Plantation, Air Pollution" },
  { name: "EPA Pakistan", problems: "Industrial Waste, Legal Action" },
  { name: "IUCN Pakistan", problems: "Biodiversity, Wetlands, Research" }
];

const ContactUs = () => {
  return (
    <div className="contact-page">
      <Navbar />

      {/* New Attractive Banner - Without Email Button */}
      <section className="contact-banner">
        <div className="leaf-animation">
          <FaLeaf className="leaf l1" />
          <FaLeaf className="leaf l2" />
          <FaSeedling className="leaf l3" />
          <FaLeaf className="leaf l4" />
        </div>
        <div className="banner-content">
          <span className="banner-badge">🌍 For a Greener Pakistan</span>
          <h1>Let's Talk & <span>Take Action</span></h1>
          <p>Found an environmental problem? Report it instantly. We're here to connect you with the right NGO.</p>
          <div className="banner-buttons">
            <Link to="/report" className="btn-banner-primary">Report an Issue →</Link>
          </div>
        </div>
        <div className="wave-divider">
          <svg viewBox="0 0 1440 120"><path d="M0,64 C288,96 576,0 864,32 C1152,64 1440,64 1440,64 L1440,120 L0,120 Z" fill="#f6faf7"></path></svg>
        </div>
      </section>

      <section className="section">
        <div className="container">
          
          <div className="grid-four-col">
            <div className="info-card">
              <div className="info-icon green"><FaEnvelope /></div>
              <div className="info-text"><h3>Email Us</h3><p>info@ecovibe.pk</p><p>support@ecovibe.pk</p></div>
            </div>
            <div className="info-card">
              <div className="info-icon orange"><FaPhone /></div>
              <div className="info-text"><h3>Call Us</h3><p>+92 300 1234567</p><p>+92 42 111-222-333</p></div>
            </div>
            <div className="info-card">
              <div className="info-icon blue"><FaMapMarkerAlt /></div>
              <div className="info-text"><h3>Visit Us</h3><p>IT Dept, Punjab University</p><p>Lahore, Pakistan</p></div>
            </div>
            <div className="info-card">
              <div className="info-icon dark"><FaClock /></div>
              <div className="info-text"><h3>Working Hours</h3><p>Mon - Fri: 9AM - 6PM</p><p>Sat: 10AM - 2PM</p></div>
            </div>
          </div>

          <div className="about-section">
            <div className="about-icon-box"><FaHandsHelping size={28} /></div>
            <h2 className="section-title">About Ecovibe</h2>
            <div className="title-line"></div>
            <p>Ecovibe bridges the gap between citizens and NGOs. Our mission is to empower every Pakistani to report environmental issues and let us connect you with the right organizations for a cleaner, greener future.</p>
          </div>

          <div className="ngo-section">
            <h2 className="section-title">🤝 Our Partner NGOs</h2>
            <p className="section-subtitle">Working together for a sustainable future</p>
            <div className="ngo-grid">
              {ngos.map((ngo) => (
                <div className="ngo-card" key={ngo.name}>
                  <div className="ngo-letter">{ngo.name.charAt(0)}</div>
                  <h4>{ngo.name}</h4>
                  <span className="ngo-focus">{ngo.problems}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="faq-section">
            <h2 className="section-title">Got Questions?</h2>
            <div className="faq-list">
              <div className="faq-item"><h4>How long does it take to review a report?</h4><p>We review all reports within 48 hours and forward them to the relevant NGO.</p></div>
              <div className="faq-item"><h4>Can I report an issue anonymously?</h4><p>Yes, you can submit a report without your name. But email is required for updates.</p></div>
              <div className="faq-item"><h4>Is it free to submit a report?</h4><p>Yes, reporting environmental issues on Ecovibe is completely free.</p></div>
              <div className="faq-item"><h4>What types of issues can I report?</h4><p>Deforestation, Water Pollution, Air Pollution, Wildlife Poaching, and Illegal Waste Dumping.</p></div>
            </div>
          </div>

        </div>
      </section>
      <Footer />
    </div>
  );
};

export default ContactUs;